import { createAction, props } from '@ngrx/store';
import { Lob, Period } from '@cmi/shared/models';
import { Company } from '@cmi/store/admin/company';

const PREFIX = '[Company]';

export const companyInitialise = createAction(`${PREFIX} Initialise`);
export const companyUpdateSelectedTab = createAction(
  `${PREFIX} Update Selected Tab`,
  props<{ selectedTab: string }>()
);
export const companyUpdateLobs = createAction(`${PREFIX} Update Lobs`, props<{ lobs: Lob[] }>());
export const companyUpdatePeriods = createAction(
  `${PREFIX} Update Periods`,
  props<{ periods: Period[] }>()
);
export const companyUpdatePeriodRange = createAction(
  `${PREFIX} Update Period Range`,
  props<{ startPeriodId: string | null; endPeriodId: string | null; isEnabled: boolean }>()
);
export const companyUpdateSelectedCompany = createAction(
  `${PREFIX} Update Selected Company`,
  props<{ company: Company | null }>()
);
export const companyUpdateLogoFile = createAction(
  `${PREFIX} Update Logo File`,
  props<{ logoFile: File | null }>()
);
export const companyUpdateCompanyValues = createAction(
  `${PREFIX} Update Company Values`,
  props<{
    name?: string | null;
    pdfCoverTitle?: string | null;
    logoFile?: File | null;
    template?: string | null;
    startPeriodId?: string | null;
    endPeriodId?: string | null;
    status?: boolean | null;
  }>()
);
export const companyUpdateOriginalValues = createAction(
  `${PREFIX} Update Original Values`,
  props<{ id: number }>()
);
export const companyUpdateSelectedLOBs = createAction(
  `${PREFIX} Update Selected LOBs`,
  props<{ selectedLobs: number[] | null }>()
);
export const companySave = createAction(`${PREFIX} Save`);
